import React from 'react';
import { reduxForm } from 'redux-form';
import { bool, func, string, oneOf } from 'prop-types';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import { noop, map } from 'lodash';

import { appPackageComponentTypes } from 'modules/application/constants';

import ComponentByIdField from './packageFormFields/ComponentByIdField';
import ContextMenuExtensionField from './packageFormFields/ContextMenuExtensionField';
import ApplicationField from './packageFormFields/ApplicationField';
import styles from '../styles/addPackageComponent.scss';

@reduxForm({
  form: 'app-package-component',
  forceUnregisterOnUnmount: true
})
export default class AppPackageComponentForm extends React.Component {
  static propTypes = {
    applicationId: string.isRequired,
    componentType: oneOf(map(appPackageComponentTypes, 'type')).isRequired,
    componentLabel: string.isRequired,
    onSubmit: func.isRequired,
    handleSubmit: func.isRequired,
    onClose: func,
    title: string,
    isEditing: bool
  };

  static defaultProps = {
    onClose: noop
  };

  state = {
    open: false
  };

  componentDidMount() {
    // eslint-disable-next-line react/no-did-mount-set-state
    this.setState({
      open: true
    });
  }

  handleCancel = () => {
    this.setState({ open: false }, () => {
      this.props.onClose();
    });
  };

  handleAddComponent = formValues => {
    if (this.props.componentType) {
      this.props.onSubmit(this.props.componentType, formValues);
    }
  };

  render() {
    const { componentType, isEditing } = this.props;
    const ApplicationComponentForm = {
      engine: ComponentByIdField,
      dataSchema: ComponentByIdField,
      contextMenuExtension: ContextMenuExtensionField,
      oauth2RedirectUrl: ApplicationField,
      appSwitcherShortcut: ApplicationField
    }[componentType];

    if (!ApplicationComponentForm) return null;

    return (
      <div>
        <Dialog
          maxWidth="md"
          open={this.state.open}
          aria-labelledby="form-add-new-component-pkg"
        >
          <form onSubmit={this.props.handleSubmit(this.handleAddComponent)}>
            <DialogTitle id="new-pkg-component-title">
              <span className={styles['title-content']}>
                {this.props.title}
                <IconButton
                  disableRipple
                  style={{ padding: '0px' }}
                  color="inherit"
                  onClick={this.props.onClose}
                >
                  <CloseIcon />
                </IconButton>
              </span>
            </DialogTitle>
            <DialogContent style={{ width: '640px' }}>
              <ApplicationComponentForm
                applicationId={this.props.applicationId}
                componentType={componentType}
                componentLabel={this.props.componentLabel}
                isEditing={isEditing}
              />
            </DialogContent>
            <DialogActions className={styles['actions-container']}>
              <Button onClick={this.handleCancel}>Cancel</Button>
              <Button type="submit" color="primary" variant="contained">
                {isEditing ? 'Save' : 'Add'}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/plugins/applications/components/AppPackageComponentForm.js